import moment from "moment";

export const dateTime: any = (
  strDate: string | number,
  type: string,
  empty?: string,
) => {
  if (empty && !strDate) {
    return empty;
  }

  const datetime = strDate !== "" ? moment(strDate) : moment();
  if (type === "iso") {
    return datetime.toISOString();
  }

  if (type === "object") {
    return datetime.toObject();
  }

  if (type === "calendar") {
    return datetime.format("L hh:mm:ss");
  }

  if (type === "choose") {
    return datetime.format("DD/MM/YYYY");
  }

  if (type === "from-now") {
    return datetime.fromNow();
  }

  if (type === "date-time") {
    return strDate && datetime.format("DD/MM/YYYY HH:mm");
  }

  if (type === "today") {
    return datetime;
  }

  if (type === "moment") {
    return datetime;
  }

  if (type === "date-time-custom") {
    return strDate && datetime.format("DD MMMM YYYY HH:mm");
  }

  if (type === "period") {
    return strDate && datetime.format("MMM Do, YYYY");
  }

  if (type === "month-first") {
    return strDate && datetime.format("MMMM D, YYYY");
  }

  if (type === "month-short") {
    return strDate && datetime.format("D MMM YYYY");
  }

  if (type === "month-first-short") {
    return strDate && datetime.format("MMM D YYYY");
  }
};

export const formattedDate = (date: string | Date) => moment(date).format("MMM DD, YYYY");
